<template>
  <div>
    <eden-table-actions :title="title" :show-search="false">
      <template slot="actions">
        <el-button
          v-if="allowAction"
          type="primary"
          @click="command({ action: 'add' })"
        >
          Add New Food Tag
        </el-button>
      </template>
    </eden-table-actions>
    <eden-loader v-if="loading" />
    <template v-else>
      <el-table v-if="pageData.length" :data="pageData">
        <el-table-column min-width="300">
          <template slot="header">
            <span> Food tag </span>
          </template>
          <template v-slot="scope">
            <p>{{ formatToTitleCase(scope.row.name) }}</p>
          </template>
        </el-table-column>
        <el-table-column min-width="300">
          <template slot="header">
            <span> Date added </span>
          </template>
          <template v-slot="scope">
            <p>{{ formatDateAndTime(scope.row.created_at, "m do, y") }}</p>
          </template>
        </el-table-column>
        <el-table-column min-width="300">
          <template slot="header">
            <span> Date updated </span>
          </template>
          <template v-slot="scope">
            <p>{{ formatDateAndTime(scope.row.updated_at, "m do, y") }}</p>
          </template>
        </el-table-column>
        <el-table-column v-if="allowAction" width="60">
          <template v-slot="scope">
            <el-dropdown @command="command" class="more">
              <span class="el-dropdown-link">
                <i class="eden-icon-more"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  icon="eden-icon-edit-write"
                  :command="{
                    action: 'edit',
                    id: scope.row.id,
                    index: scope.$index,
                  }"
                  >Edit Food Tag</el-dropdown-item
                >
                <el-dropdown-item
                  icon="eden-icon-delete"
                  :command="{
                    action: 'delete',
                    id: scope.row.id,
                    index: scope.$index,
                  }"
                  >Delete Food Tag</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <eden-content-empty v-else :text="'No food tags'" />
    </template>
    <food-tag-form
      :show.sync="foodTag.visibility"
      :action="foodTag.action"
      :food-tag="foodTag.data"
      @success="getFoodTags"
    />
    <food-tag-delete
      :show.sync="showFoodTagDelete"
      :food-tag="foodTag.data"
      @success="getFoodTags"
    />
  </div>
</template>

<script>
import tags from "@/requests/services/meal/food-tags";
import FoodTagForm from "@/components/Services/Meal/FoodTags/FoodTagForm";
import FoodTagDelete from "@/components/Services/Meal/FoodTags/FoodTagDelete";

export default {
  name: "FoodTags",
  components: { FoodTagDelete, FoodTagForm },
  data() {
    return {
      loading: false,
      pageData: [],
      showFoodTagDelete: false,
      foodTag: {
        action: "add",
        visibility: false,
        data: {},
      },
    };
  },
  computed: {
    title() {
      return `${this.pageData.length} Food Tags`;
    },
    allowAction() {
      return this.allowAccessFor(["admin", "operations", "kitchen"]);
    },
  },
  created() {
    this.getFoodTags();
  },
  methods: {
    getFoodTags() {
      this.loading = true;
      tags
        .list()
        .then((response) => {
          const { status, data } = response;
          if (status) {
            this.pageData = data.data;
            this.loading = false;
          } else {
            this.$message.error("Error loading Food Tags.");
            this.loading = false;
          }
        })
        .catch(() => {
          this.$message.error("An error occurred.");
          this.loading = false;
        });
    },
    command(command) {
      switch (command.action) {
        case "add":
          this.foodTag.data = {};
          this.foodTag.action = "add";
          this.foodTag.visibility = true;
          break;
        case "edit":
          this.foodTag.data = this.pageData[command.index];
          this.foodTag.action = "edit";
          this.foodTag.visibility = true;
          break;
        case "delete":
          this.foodTag.data = this.pageData[command.index];
          this.showFoodTagDelete = true;
          break;
        default:
          break;
      }
    },
  },
};
</script>
